import React, { useState, useEffect } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Col, Form, Row, Image, Button, Modal } from "react-bootstrap";
import { TextField, FormControl, Select } from "@material-ui/core";
import Switch from "react-switch";
import moment from "moment";
import CustomSuperAdminNotification from "../../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/CustomSuperAdminNotification";
import SuperAdminSmsAdmin from "../../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminSmsAdmin";
import SuperAdminCall from "../../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminCall";
import NewCountDown from "../../../../../reusableComponents/allPopupReusable/tableNumberPopup/NewCountDown";
import InputNumberFunc from "../../../../../../function/InputNumberFunc";
import { InputCharacterCheck } from "../../../../../../function/InputCharNumCheckFunc";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import isEmpty from "../../../../../../store/validation/is-Empty";
// import { update_diner_info_by_admin } from "../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";
import { rsvp_edit_perticular_event_request } from "../../../../../../store/actions/RsvpEventDashboard/RsvpEventDashboardAction";
import { get_all_vendor_seating_information } from "../../../../../../store/actions/SuperAdminActions/adminSeatingDashboardAllAction";
import EditWaitTime from "../../../../../reusableComponents/allPopupReusable/tableNumberPopup/EditWaitTime";
import AllActionPopup from "../AllActionPopup/AllActionPopup";
import EnterTableNumber from "../../../../../reusableComponents/allPopupReusable/tableNumberPopup/EnterTableNumber";

const EditRsvpOfflineEvent = (props) => {
  //state
  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = () => {
    setShowEdit(true);
  };

  /*******************************
   * @DESC Pending Total Wait time
   *******************************/
  const currentTime = new Date();
  var endTime = moment(currentTime).format("YYYY-MM-DDTHH:mm");
  const createdAt = new Date(props.dataSend.createdAt);
  var startTime = moment(createdAt).format("YYYY-MM-DDTHH:mm");

  let dateOne = new Date(startTime);
  let dateTwo = new Date(endTime);

  let msDifference = dateTwo - dateOne;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function time_convertPending(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  /*******************************
   * @DESC Seating Total Wait time
   *******************************/
  const seatedTime = new Date(props.dataSend.seatedTime);
  const updatedAt = new Date(props.dataSend.updatedAt);
  var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  var updatedTimeNew = moment(updatedAt).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);
  let dataThreeSeated = new Date(updatedTimeNew);

  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let totalUpdatedTime = dataThreeSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);
  let minutesUpdatedTime = Math.floor(totalUpdatedTime / 1000 / 60);

  function seated_time_difference(minutesSeated) {
    var hours = Math.floor(minutesSeated / 60);
    var nMinutesSeated = minutesSeated % 60;
    return hours + " HH : " + nMinutesSeated + " min";
  }

  function upated_time_difference(minutesUpdatedTime) {
    var hours = Math.floor(minutesUpdatedTime / 60);
    var nMinutesUpdatedTime = minutesUpdatedTime % 60;
    return hours + " HH : " + nMinutesUpdatedTime + " min";
  }

  /**************************
   *@DESC Total Wait Time Diff
   ***************************/
  const updatedTime = new Date(props.dataSend.wait_time_date);
  const currentTimeTwo = new Date().getTime();
  const updatedTimeNewDiff = updatedTime.getTime();
  const waitTime = Math.abs(props.dataSend.wait_time) * 60 * 1000;
  let updateWaitTime = updatedTimeNewDiff + waitTime;
  let diff = updateWaitTime - currentTimeTwo;

  const history = useHistory();
  const [state, setState] = useState({
    isLoading: false,
    number: "",
    name: "",
    highChairHandiCapped: false,
    roomNumber: "",
    tableNumber: "",
    specialOcassion: "",
    open: false,
  });
  const [code, setCode] = useState("");
  const [adult, setAdult] = useState(0);
  const [kids, setKids] = useState(0);
  const [handicap, setHandicap] = useState(0);
  const [highchair, setHighchair] = useState(0);
  const [seatingPreference, setSeatingPreference] = useState({
    seatingPreference: "",
  });
  const [checkedBox, setCheckedBox] = useState(false);
  const handleChangeSwitch = (e) => {
    setCheckedBox(!checkedBox);
  };

  useEffect(() => {
    setState({
      number: !isEmpty(props.dataSend.user_details.mobile_number)
        ? props.dataSend.user_details.mobile_number
        : "",
      name: !isEmpty(props.dataSend.user_details.name)
        ? props.dataSend.user_details.name
        : "",
      highChairHandiCapped:
        props.dataSend.handicap_chair && props.dataSend.high_chair === 0
          ? false
          : true,
      roomNumber: !isEmpty(props.dataSend.room_number)
        ? props.dataSend.room_number
        : "",
      tableNumber: !isEmpty(props.dataSend.table_number)
        ? props.dataSend.table_number
        : "",
      specialOcassion: !isEmpty(props.dataSend.occasion)
        ? props.dataSend.occasion
        : "",
    });
    setCode(
      !isEmpty(props.dataSend.user_details.country_code)
        ? props.dataSend.user_details.country_code
        : ""
    );
    setAdult(
      !isEmpty(props.dataSend.adult_count) ? props.dataSend.adult_count : 0
    );
    setKids(
      !isEmpty(props.dataSend.kids_count) ? props.dataSend.kids_count : 0
    );
    setHandicap(
      !isEmpty(props.dataSend.handicap_chair)
        ? props.dataSend.handicap_chair
        : 0
    );
    setHighchair(
      !isEmpty(props.dataSend.high_chair) ? props.dataSend.high_chair : 0
    );
    setSeatingPreference({
      seatingPreference: !isEmpty(props.dataSend.seating_preference[0])
        ? props.dataSend.seating_preference[0]
        : "",
    });
    setCheckedBox(
      props.dataSend.handicap_chair || props.dataSend.high_chair === 0
        ? false
        : true
    );
  }, []);

  const vendorInfo = useSelector((state) => {
    return state.onboarding.restaurantDetails;
  });

  const token = useSelector((state) => {
    return state.auth.user;
  });

  const dispatch = useDispatch();

  const handleChangeCode = (event) => {
    setCode(event.target.value);
  };

  const onChange = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };
  const onChangeNumber = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    setState({
      ...state,
      [e.target.name]: number,
    });
  };

  /***************************
   * @DESC on Button Handler
   ***************************/
  const onButtonClick = (e, type) => {
    e.preventDefault();
    setSeatingPreference({
      seatingPreference: type,
    });
  };

  const IncrementKidsItem = (e) => {
    e.preventDefault();
    if (adult === 0) {
      if (kids < 100) {
        setKids(kids + 1);
        setAdult(adult + 1);
      } else {
        setKids(kids + 1);
      }
    } else {
      setKids(kids + 1);
    }
  };
  const IncrementAdultItem = (e) => {
    e.preventDefault();
    if (adult < 100) {
      setAdult(adult + 1);
    } else {
      return null;
    }
  };
  const IncrementhandicapItem = (e) => {
    e.preventDefault();
    if (handicap < 100) {
      setHandicap(handicap + 1);
    } else {
      return null;
    }
  };
  const IncrementhighchairItem = (e) => {
    e.preventDefault();
    if (highchair < 100) {
      setHighchair(highchair + 1);
    } else {
      return null;
    }
  };

  const DecreaseKidsItem = (e) => {
    e.preventDefault();
    if (kids > 0) {
      setKids(kids - 1);
    } else {
      return null;
    }
  };

  const DecreaseAdultItem = (e) => {
    e.preventDefault();
    if (adult > 0) {
      setAdult(adult - 1);
    } else {
      return null;
    }
  };

  const DecreaseHandicapItem = (e) => {
    e.preventDefault();
    if (handicap > 0) {
      setHandicap(handicap - 1);
    } else {
      return null;
    }
  };
  const DecreaseHighchairItem = (e) => {
    e.preventDefault();
    if (highchair > 0) {
      setHighchair(highchair - 1);
    } else {
      return null;
    }
  };

  const onCloseModal = () => {
    setState({
      ...state,
      open: !state.open,
    });
  };

  const handleSubmit = (e) => {
    const eventId = props.dataSend._id;
    const vendor_id = token.VendorUser._id;
    const tokenData = token.accessToken;
    const formData = {
      kids_count: kids,
      adult_count: adult,
      handicap_chair: handicap,
      high_chair: highchair,
      occasion: state.specialOcassion,
      //   seating_preference: seatingPreference.seatingPreference,
      room_number: state.roomNumber,
      table_number: state.tableNumber,
      user_details: {
        country_code: code,
        deviceToken: "",
        mobile_number: state.number,
        name: state.name,
      },
    };
    // console.log(formData);
    dispatch(
      rsvp_edit_perticular_event_request(
        formData,
        eventId,
        tokenData,
        onSuccess
      )
    );
  };

  const onSuccess = (e) => {
    // const data = { vendor_id: vendorInfo.vendor_id };
    // dispatch(get_all_vendor_seating_information(data));
    handleCloseEdit();
  };

  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={handleShowEdit}
      >
        <Image
          src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
          alt="Edit"
          title="Edit"
          fluid
        />
      </Button>
      <Modal show={showEdit} onHide={handleCloseEdit} centered size="lg">
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">Edit Diner</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <Form className="py-4">
            <div
              className={`enGrayBorderBox ${
                props.dataSend.service_type === "RESERVATION"
                  ? "enLeftYellowLine"
                  : "enLeftGReenLine"
              } mb-4`}
            >
              <Row className="px-3">
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Name/Request Number</div>
                  <div className="d-flex">
                    <div className="order-type-Image">
                      {props.dataSend.isWalkIn === true &&
                      props.dataSend.service_type === "SEATING" ? (
                        <Image
                          src={require("../../../../../../assets/images/ActionImages/image/walkin.svg")}
                          alt="Order Type"
                          title="Order Type"
                          width="16px"
                        />
                      ) : null ||
                        (props.dataSend.isWalkIn === false &&
                          props.dataSend.service_type === "SEATING") ? (
                        <Image
                          src={require("../../../../../../assets/images/ActionImages/image/waitlist.svg")}
                          alt="Order Type"
                          title="Order Type"
                          width="16px"
                        />
                      ) : null ||
                        props.dataSend.service_type === "RESERVATION" ? (
                        <Image
                          src={require("../../../../../../assets/images/ActionImages/image/reservation.svg")}
                          alt="Order Type"
                          title="Order Type"
                          width="16px"
                        />
                      ) : null}
                      {/* <Image
                        src={require("../../../../../../assets/images/UserManagement/walkin.svg")}
                        alt="View"
                        title="View"
                        width="9px"
                      /> */}
                    </div>
                    <div className="pl-2">
                      <div className="f15-500">
                        {props.dataSend.user_details.name}
                      </div>
                      <div className="f9-400">
                        #{props.dataSend.event_request_id}
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Total PAX</div>
                  <div className="adult-total-box">
                    <div className="d-flex align-items-center">
                      <p className="f18-700 text-dark mr-2">
                        {props.dataSend.adult_count + props.dataSend.kids_count}
                      </p>
                      <div className="adult-total-box-two mr-2">
                        {props.dataSend.adult_count === 0 ? null : (
                          <div className="d-flex align-items-center justify-content-around mb-2">
                            <div className="adult-total-box-two-insideone">
                              <Image
                                src={require("../../../../../../assets/images/ActionImages/employees.png")}
                                fluid
                                alt="Adult"
                                title="Adult"
                                className="icon-image"
                              />
                            </div>
                            <span className="pl-1">
                              {props.dataSend.adult_count}
                            </span>
                          </div>
                        )}
                        {props.dataSend.kids_count === 0 ? null : (
                          <div className="d-flex align-items-center justify-content-around">
                            <div className="adult-total-box-two-insideone">
                              <Image
                                src={require("../../../../../../assets/images/ActionImages/children.png")}
                                fluid
                                alt="Children"
                                title="Children"
                                className="icon-image"
                              />
                            </div>
                            <span className="pl-1">
                              {props.dataSend.kids_count}
                            </span>
                          </div>
                        )}
                      </div>
                      <div className="adult-total-box-three">
                        {props.dataSend.handicap_chair === 0 ? null : (
                          <div className="d-flex align-items-center justify-content-around mb-2">
                            <div className="adult-total-box-three-insideone">
                              <Image
                                src={require("../../../../../../assets/images/ActionImages/highchair.png")}
                                fluid
                                alt="Highchair"
                                title="Highchair"
                                className="icon-image-small"
                              />
                            </div>
                            <span className="pl-1">
                              {props.dataSend.handicap_chair}
                            </span>
                          </div>
                        )}
                        {props.dataSend.high_chair === 0 ? null : (
                          <div className="d-flex align-items-center justify-content-around">
                            <div className="adult-total-box-three-insideone">
                              <Image
                                src={require("../../../../../../assets/images/ActionImages/wheelchair.png")}
                                fluid
                                alt="Wheel Chair"
                                title="Wheel Chair"
                                className="icon-image-small"
                              />
                            </div>
                            <span className="pl-1">
                              {props.dataSend.high_chair}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Date / Time / Timer</div>
                  <div className="f18-700 text-red d-flex align-items-center">
                    <div className="timer-section mr-2">
                      <h4 className="timer-count">
                        <NewCountDown waitNew={diff} />
                      </h4>
                    </div>
                    {props.dataSend.event_status === "REJECTED" ||
                    props.dataSend.event_status === "CANCELLED" ||
                    props.dataSend.event_status === "COMPLETED" ? (
                      ""
                    ) : (
                      <EditWaitTime
                        allDataProps={props.dataSend._id}
                        actionBy="RsvpEvent"
                        status={props.dataSend}
                      />
                    )}
                  </div>
                  <div className="f12-400">
                    {moment(props.dataSend && props.dataSend.updatedAt).format(
                      "Do MMM, YYYY"
                    )}
                  </div>
                  <div className="f12-400">
                    {moment(props.dataSend && props.dataSend.updatedAt).format(
                      "hh:mm A"
                    )}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Seating Preference</div>
                  <div className="d-flex flex-wrap">
                    {props.dataSend &&
                      props.dataSend.seat_number.map((data, index) => {
                        return (
                          <React.Fragment key={index}>
                            <div className="f12-400">{data},&nbsp;</div>
                          </React.Fragment>
                        );
                      })}
                  </div>
                </Col>
              </Row>
              <hr className="m-0" />
              <Row className="px-3">
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Date & Time</div>
                  <div className="f12-400">
                    {moment(props.dataSend.createdAt).format("Do MMMM YYYY")}
                  </div>
                  <div className="f12-400">
                    {moment(props.dataSend.createdAt).format("hh:mm A")}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">
                    Track User
                    <br />
                    Location
                  </div>
                  <div className="ml-4 pl-1">
                    <Image
                      fluid
                      src={require("../../../../../../assets/images/ActionImages/maps-and-flagsred.png")}
                      alt="Location Icon"
                      width="13px"
                      title="Location"
                    />
                  </div>
                </Col>
                <Col lg={6} md={6} className="py-3">
                  <div className="d-flex justify-content-center align-items-center">
                    {props.pathname === "/offline-events-rsvp" &&
                    props.dataSend.event_status === "PENDING" ? (
                      <AllActionPopup
                        buttonDisplay="smallCancelButton"
                        displayPopup="resonFforCancellation"
                        actionCall={"rsvpReject"}
                        buttonText="Reject"
                        bigText="Request Reject"
                        reasonText="Are you sure to Reject ?"
                        dataSend={props.dataSend}
                      />
                    ) : props.pathname === "/offline-events-rsvp" &&
                      props.dataSend.event_status === "NOTSEATED" ? (
                      <AllActionPopup
                        buttonDisplay="smallCancelButton"
                        displayPopup="resonFforCancellation"
                        actionCall="rsvpCancel"
                        buttonText="Cancel"
                        bigText="Request Cancel"
                        reasonText="Are you sure to Cancel ?"
                        dataSend={props.dataSend}
                      />
                    ) : props.pathname === "/offline-events-rsvp" &&
                      props.dataSend.event_status === "SEATED" ? (
                      <AllActionPopup
                        buttonDisplay="smallCancelButton"
                        displayPopup="seatingUnseated"
                        buttonText="Unseat"
                        bigText="Request Unseat"
                        display={true}
                        reasonText="Are you sure to Unseat ?"
                        dataSend={props.dataSend}
                        // subscription_id={props.subscription_id}
                      />
                    ) : (props.pathname === "/offline-events-rsvp" &&
                        props.dataSend.event_status === "COMPLETED") ||
                      (props.pathname === "/offline-events-rsvp" &&
                        props.dataSend.event_status === "REJECTED") ||
                      (props.pathname === "/offline-events-rsvp" &&
                        props.dataSend.event_status === "CANCELLED") ? (
                      <AllActionPopup
                        buttonDisplay="smallCancelButton"
                        displayPopup="historyReset"
                        buttonText="Reset"
                        bigText="Request Reset"
                        reasonText="Are you sure to Reset ?"
                        dataSend={props.dataSend}
                        // subscription_id={props.subscription_id}
                      />
                    ) : null}
                    <div className="middle-timer ml-4 mr-4">
                      <p className="f12-400 text-center ">Total Wait time</p>
                      <div className="count-down-timer d-flex mt-2 mb-2">
                        <i
                          className="fa fa-hourglass-half mr-3"
                          aria-hidden="true"
                        ></i>
                        <p className="font_16_m">
                          {props.dataSend.event_status === "NOTSEATED"
                            ? time_convertPending(minutes)
                            : seated_time_difference(minutesSeated)}
                        </p>
                      </div>
                      <p className="font_20_r">
                        Status:&nbsp;
                        <span className="font_20_b">
                          {/* {props.dataSend.diner_status === "NOTSEATED"
                              ? "NOT SEATED"
                              : "SEATED"} */}
                          {props.dataSend.event_status}
                        </span>
                      </p>
                    </div>
                    {props.pathname === "/offline-events-rsvp" &&
                    props.dataSend.event_status === "PENDING" ? (
                      // <AllActionPopup
                      //   buttonDisplay="acceptButtonReservation"
                      //   // displayPopup="acceptButtonReservation"
                      //   buttonText="Accept"
                      //   bigText="Request Accept"
                      //   reasonText="Are you sure you want to accept ?"
                      //   dataSend={props.dataSend}
                      // />

                      // <EditWaitTime
                      //   buttonText="Accept"
                      //   editButtonStatus="pendingEdit"
                      //   closedMainModal={onCloseModal}
                      //   allDataProps={props.dataSend._id}
                      // />
                      <AllActionPopup
                        buttonDisplay="acceptButtonReservation"
                        // displayPopup="acceptButtonReservation"
                        actionButton="acceptPendingButton"
                        diffrenceTime={diff}
                        buttonText="Accept"
                        bigText="Request Accept"
                        reasonText="Are you sure you want to accept ?"
                        dataSend={props.dataSend}
                      />
                    ) : props.pathname === "/offline-events-rsvp" &&
                      props.dataSend.event_status === "NOTSEATED" ? (
                      <EnterTableNumber
                        buttonText="Seat"
                        actionBy="RsvpTable"
                        eventId={props.dataSend}
                        closedMainModal={onCloseModal}
                        allDataProps={props.dataSend}
                      />
                    ) : props.pathname === "/offline-events-rsvp" &&
                      props.dataSend.event_status === "SEATED" ? (
                      <AllActionPopup
                        buttonDisplay="seatingCompleted"
                        displayPopup="seatingCompleted"
                        buttonText="Complete"
                        bigText="Request Complete"
                        reasonText="Are you sure to Completed ?"
                        dataSend={props.dataSend}
                        // subscription_id={props.subscription_id}
                      />
                    ) : null}
                    {/* <button className="btn btn-danger enWidth75" type="button">
                      Cancel
                    </button>
                    <div className="px-2">
                      <div className="enTimesLbl d-flex justify-content-center align-items-center">
                        <Image
                          src={require("../../../../../../assets/images/UserManagement/hourglass.svg")}
                          alt="Edit"
                          title="Edit"
                          width="10px"
                        />
                        <p className="f10-500 text-dark pl-2">
                          {" "}
                          {props.dataSend.diner_status === "PENDING" ||
                          props.dataSend.diner_status === "NOTSEATED"
                            ? time_convertPending(minutes)
                            : props.dataSend.diner_status === "SEATED" ||
                              props.dataSend.diner_status === "COMPLETED"
                            ? seated_time_difference(minutesSeated)
                            : props.dataSend.diner_status === "REJECTED" ||
                              props.dataSend.diner_status === "CANCELLED"
                            ? upated_time_difference(minutesUpdatedTime)
                            : null}
                        </p>
                      </div>
                    </div>
                    <button className="btn btn-success enWidth75" type="button">
                      Seat
                    </button> */}
                  </div>
                </Col>
              </Row>
              <hr className="m-0" />
              <Row className="px-3">
                <Col lg={3} md={6} className="py-3">
                  <div className="d-flex flex-wrap align-items-center py-3 enWidth130">
                    <div className="mb-3">
                      <SuperAdminCall />
                    </div>
                    <Button variant="link" className="enIconBtn mr-3 mb-3">
                      <Image
                        src={require("../../../../../../assets/images/UserManagement/forum.svg")}
                        alt="View"
                        title="View"
                        fluid
                      />
                    </Button>
                    <SuperAdminSmsAdmin />
                    <CustomSuperAdminNotification />
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Table / Room No.</div>
                  <div className="f12-400">
                    Table No. - {props.dataSend.table_number}
                  </div>
                  <div className="f12-400">
                    Room No. - {props.dataSend.room_number}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Special Occasion</div>
                  <div className="f12-400">{props.dataSend.occasion}</div>
                  {/* <Button variant="link" className="text-red f12-400 p-0">
                    See more
                  </Button> */}
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Status / Location</div>
                  <div className="f13-400">
                    <span className="enYellowDot mr-1"></span>
                    {props.dataSend.event_status}
                  </div>
                </Col>
              </Row>
            </div>
            <Row>
              <Col md={12}>
                <Row>
                  <Col md={6}>
                    <Row>
                      <Col xs={4} className="pr-0">
                        <Form.Group controlId={"code"}>
                          <FormControl variant="outlined" className="w-100">
                            <Select
                              value={code}
                              onChange={handleChangeCode}
                              inputProps={{
                                name: "code",
                              }}
                            >
                              {/* <option value={code}>{code}</option> */}
                              {getCountries().map((country) => (
                                <option
                                  key={country}
                                  value={"+" + getCountryCallingCode(country)}
                                >
                                  {en[country]} (+
                                  {getCountryCallingCode(country)})
                                </option>
                              ))}
                            </Select>
                          </FormControl>
                          {/* <Select
                              value="+91"
                              onChange={handleChangeCode}
                              inputProps={{
                                name: "code",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              <option value={+91}>+91</option>
                            </Select> */}
                        </Form.Group>
                      </Col>
                      <Col xs={8}>
                        <Form.Group>
                          <TextField
                            id="outlined-basic"
                            label="Phone Number"
                            variant="outlined"
                            className="w-100"
                            value={state.number}
                            onChange={onChangeNumber}
                            type="number"
                            onKeyDown={InputNumberFunc}
                            inputProps={{
                              name: "number",
                              maxLength: 10,
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <TextField
                        id="outlined-basic"
                        label="Name"
                        variant="outlined"
                        className="w-100"
                        value={state.name}
                        onChange={onChange}
                        type="text"
                        onKeyDown={InputCharacterCheck}
                        inputProps={{
                          name: "name",
                          maxLength: 50,
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={12} lg={8}>
                    <div className="f16-500 py-3">Party Size</div>
                    <div className="d-flex enPartySize">
                      <div className="d-flex pr-3 pb-3">
                        <div className="enKidsIcon">
                          <Image
                            src={require("../../../../../../assets/images/ActionImages/children.png")}
                            alt="View"
                            title="View"
                            width="9px"
                          />
                        </div>
                        <div className="pl-md-2 enPartyPersonEdit">
                          <div className="f14-500 pb-2">Kids</div>
                          <div className="d-flex align-items-center">
                            <Button
                              variant="link"
                              className="p-0"
                              onClick={DecreaseKidsItem}
                            >
                              <Image
                                src={require("../../../../../../assets/images/UserManagement/minus.svg")}
                                alt="Minus"
                                title="Minus"
                                fluid
                              />
                            </Button>
                            <input
                              placeholder="00"
                              className="enInputValueOnly f12-700"
                              value={kids}
                              readOnly
                            />
                            <Button
                              variant="link"
                              className="p-0"
                              onClick={IncrementKidsItem}
                            >
                              <Image
                                src={require("../../../../../../assets/images/UserManagement/plus.svg")}
                                alt="Minus"
                                title="Minus"
                                fluid
                              />
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex border-left pl-3 pb-3">
                        <div className="enKidsIcon">
                          <Image
                            src={require("../../../../../../assets/images/ActionImages/employees.png")}
                            alt="View"
                            title="View"
                            width="9px"
                          />
                        </div>
                        <div className="pl-md-2 enPartyPersonEdit">
                          <div className="f14-500 pb-2">Adult</div>
                          <div className="d-flex align-items-center">
                            <Button
                              variant="link"
                              className="p-0"
                              onClick={DecreaseAdultItem}
                            >
                              <Image
                                src={require("../../../../../../assets/images/UserManagement/minus.svg")}
                                alt="Minus"
                                title="Minus"
                                fluid
                              />
                            </Button>
                            <input
                              placeholder="00"
                              className="enInputValueOnly f12-700"
                              value={adult}
                              readOnly
                            />
                            <Button
                              variant="link"
                              className="p-0"
                              onClick={IncrementAdultItem}
                            >
                              <Image
                                src={require("../../../../../../assets/images/UserManagement/plus.svg")}
                                alt="Minus"
                                title="Minus"
                                fluid
                              />
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div className="d-flex align-items-center pb-4">
                      <div className="f16-500">
                        Need Handicap access or a Highchair?
                      </div>
                      <div className="d-flex align-items-center py-4 pl-md-4">
                        <div className="f16-500 mr-2">No</div>
                        <Switch
                          onChange={handleChangeSwitch}
                          checked={checkedBox}
                          offColor="#EEEEEE"
                          onColor="#EEEEEE"
                          offHandleColor="#212121"
                          onHandleColor="#59F832"
                          handleDiameter={24}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={15}
                          width={41}
                          boxShadow="-2px 0px 5px #0000003B"
                          activeBoxShadow="-2px 0px 5px #0000003B"
                          id="material-switch"
                          // disabled={disabled === true ? true : false}
                        />
                        <div className="f16-500 ml-2">Yes</div>
                      </div>
                    </div>
                    {checkedBox === false ? null : (
                      <div className="d-flex enPartySize pb-4">
                        <div className="d-flex pr-3 pb-3">
                          <div className="enKidsIcon">
                            <Image
                              src={require("../../../../../../assets/images/ActionImages/wheelchair.png")}
                              alt="View"
                              title="View"
                              className="custom"
                            />
                          </div>
                          <div className="pl-md-2 enPartyPersonEdit">
                            <div className="f14-500 pb-2">Handicap</div>
                            <div className="d-flex align-items-center">
                              <Button
                                variant="link"
                                className="p-0"
                                onClick={DecreaseHandicapItem}
                              >
                                <Image
                                  src={require("../../../../../../assets/images/UserManagement/minus.svg")}
                                  alt="Minus"
                                  title="Minus"
                                  fluid
                                />
                              </Button>
                              <input
                                placeholder="00"
                                className="enInputValueOnly f12-700"
                                value={handicap}
                                readOnly
                              />
                              <Button
                                variant="link"
                                className="p-0"
                                onClick={IncrementhandicapItem}
                              >
                                <Image
                                  src={require("../../../../../../assets/images/UserManagement/plus.svg")}
                                  alt="Minus"
                                  title="Minus"
                                  fluid
                                />
                              </Button>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex border-left pl-3 pb-3">
                          <div className="enKidsIcon">
                            <Image
                              src={require("../../../../../../assets/images/ActionImages/highchair.svg")}
                              alt="View"
                              title="View"
                              className="custom"
                            />
                          </div>
                          <div className="pl-md-2 enPartyPersonEdit">
                            <div className="f14-500 pb-2">Highchair</div>
                            <div className="d-flex align-items-center">
                              <Button
                                variant="link"
                                className="p-0"
                                onClick={DecreaseHighchairItem}
                              >
                                <Image
                                  src={require("../../../../../../assets/images/UserManagement/minus.svg")}
                                  alt="Minus"
                                  title="Minus"
                                  fluid
                                />
                              </Button>
                              <input
                                placeholder="00"
                                className="enInputValueOnly f12-700"
                                value={highchair}
                                readOnly
                              />
                              <Button
                                variant="link"
                                className="p-0"
                                onClick={IncrementhighchairItem}
                              >
                                <Image
                                  src={require("../../../../../../assets/images/UserManagement/plus.svg")}
                                  alt="Minus"
                                  title="Minus"
                                  fluid
                                />
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <Row>
                      <Col md={5}>
                        <Form.Group>
                          <TextField
                            id="outlined-basic"
                            label="Room No."
                            variant="outlined"
                            className="w-100"
                            value={state.roomNumber}
                            onChange={onChangeNumber}
                            type="number"
                            onKeyDown={InputNumberFunc}
                            inputProps={{
                              name: "roomNumber",
                              maxLength: 3,
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={5}>
                        <Form.Group>
                          <TextField
                            id="outlined-basic"
                            label="Table No."
                            variant="outlined"
                            className="w-100"
                            value={state.tableNumber}
                            onChange={onChangeNumber}
                            type="number"
                            onKeyDown={InputNumberFunc}
                            inputProps={{
                              name: "tableNumber",
                              maxLength: 3,
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col md={12}>
                        <div className="f16-500 pb-1 pt-3">
                          Seating Preference
                        </div>
                        <div className="f12-400 pb-3">
                          Seating is a subject to availability. Your Preference
                          will be considered.
                        </div>
                      </Col>
                      {vendorInfo.selected_seating_area &&
                        vendorInfo.selected_seating_area.map((item, index) => (
                          <Col md={4} key={index}>
                            <div
                              className="enCheckWithText w-100"
                              onChange={(e) => onButtonClick(e, item.title)}
                            >
                              <input
                                type="radio"
                                name="SeatingPreference"
                                checked={
                                  seatingPreference.seatingPreference ===
                                  item.title
                                    ? true
                                    : ""
                                }
                              />
                              <label className="w-100 d-flex align-items-center justify-content-center">
                                {/* <Image
                              src={require("../../../../../../assets/images/UserManagement/chairs.svg")}
                              alt="chairs"
                              title="chairs"
                              className="mr-2"
                                /> *
                                {item.title}
                              </label>
                            </div>
                          </Col>
                        ))}
                    </Row> */}
                  </Col>
                  <Col md={12}>
                    <div className="f16-500 pt-3 pb-2">Special Occasion</div>
                    <Form.Group>
                      <TextField
                        id="outlined-multiline-static"
                        multiline
                        rows={5}
                        placeholder="eg. Wedding Anniversary"
                        variant="outlined"
                        className="w-100"
                        value={state.specialOcassion}
                        onChange={onChange}
                        type="text"
                        inputProps={{
                          name: "specialOcassion",
                        }}
                      />
                    </Form.Group>
                    <div className="d-flex align-items-center pt-4">
                      <Button
                        variant="outline-secondary"
                        className="btn150px btn-lg mr-4 px-5"
                        onClick={(e) => handleCloseEdit()}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="danger"
                        className="btn150px btn-lg px-5"
                        onClick={handleSubmit}
                      >
                        Save
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
export default EditRsvpOfflineEvent;
